module.exports = require('./helpers/bundle-url').getBundleURL('bu0dN') + "ec23f5702ae68_001.68afa0e7.webp";